import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { ApiCallService } from './api-call-service.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ErrorhandlingService {
  showModalSubject = new BehaviorSubject<boolean>(false);

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private toastr: ToastrService,
    private apicalling: ApiCallService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  public showAlert(
    icon: 'warning' | 'error' | 'success',
    text: string,
    compact = true,
    autoCloseMs?: number
  ) {
    this.spinner.hide();

    const config = {
      timeOut: autoCloseMs || 3500,
      closeButton: true,
      progressBar: true,
      toastClass: 'ngx-toastr toast-custom',
    };

    if (icon === 'success') {
      this.toastr.success(text, 'Success!', config);
    } else if (icon === 'error') {
      this.toastr.error(text, 'Error!', config);
    } else if (icon === 'warning') {
      this.toastr.warning(text, 'Warning!', config);
    }
  }
    // const defaultTimers: Record<string, number> = {
    //   warning: 3500,
    //   error: 5000,
    //   success: 2200,
    // };

    // const timer =
    //   typeof autoCloseMs === 'number' ? autoCloseMs : defaultTimers[icon];

    // Swal.fire({
    //   icon,
    //   title:
    //     icon === 'error'
    //       ? 'Error!'
    //       : icon === 'warning'
    //       ? 'Warning!'
    //       : 'Success!',
    //   text,
    //   customClass: { popup: compact ? 'swal-compact' : '' },
    //   showClass: {
    //     popup: 'animate__animated animate__backInUp animate__fast',
    //   },
    //   hideClass: {
    //     popup: 'animate__animated animate__backOutUp animate__fast',
    //   },
    //   ...(timer > 0
    //     ? {
    //         timer,
    //         timerProgressBar: true,
    //         didOpen: () => {
    //           const popup = Swal.getPopup();
    //           if (!popup) return;
    //           popup.addEventListener('mouseenter', Swal.stopTimer);
    //           popup.addEventListener('mouseleave', Swal.resumeTimer);

    //           // Fallback: if SweetAlert2 doesn't inject the timer bar, create our own and animate it
    //           const existing = popup.querySelector('.swal2-timer-progress-bar');
    //           if (!existing) {
    //             const bar = document.createElement('div');
    //             bar.className = 'swal2-timer-progress-bar';
    //             const fill = document.createElement('div');
    //             fill.className = 'swal2-timer-progress-filled';
    //             bar.appendChild(fill);
    //             popup.appendChild(bar);

    //             // animate width from 100% -> 0% over `timer` ms
    //             const start = performance.now();
    //             const duration = timer as number;
    //             let rafId: number | null = null;

    //             const frame = (now: number) => {
    //               const elapsed = now - start;
    //               const pct = Math.max(0, 1 - elapsed / duration);
    //               fill.style.width = `${pct * 100}%`;
    //               if (pct > 0) rafId = requestAnimationFrame(frame);
    //             };

    //             rafId = requestAnimationFrame(frame);

    //             // Pause/resume on hover
    //             const pause = () => {
    //               if (rafId) cancelAnimationFrame(rafId);
    //             };
    //             const resume = () => {
    //               const w = parseFloat(fill.style.width) || 0;
    //               const remaining = (w / 100) * duration;
    //               const newStart = performance.now() - (duration - remaining);
    //               const frameResume = (now: number) => {
    //                 const elapsed = now - newStart;
    //                 const pct = Math.max(0, 1 - elapsed / duration);
    //                 fill.style.width = `${pct * 100}%`;
    //                 if (pct > 0) rafId = requestAnimationFrame(frameResume);
    //               };
    //               rafId = requestAnimationFrame(frameResume);
    //             };

    //             popup.addEventListener('mouseenter', pause);
    //             popup.addEventListener('mouseleave', resume);

    //             const observer = new MutationObserver(() => {
    //               if (!document.body.contains(popup)) {
    //                 if (rafId) cancelAnimationFrame(rafId);
    //                 observer.disconnect();
    //               }
    //             });
    //             observer.observe(document.body, {
    //               childList: true,
    //               subtree: true,
    //             });
    //           }
    //         },
    //         willClose: () => {
    //           const popup = Swal.getPopup();
    //           if (!popup) return;
    //           popup.removeEventListener('mouseenter', Swal.stopTimer);
    //           popup.removeEventListener('mouseleave', Swal.resumeTimer);
    //         },
    //       }
    //     : {}),
    // });
  

  handleResponseError(response: any): void {
    if (response.responseCode === 400) {
      if (
        response.errorMessage ===
          'You dont have sufficient balance for this request' ||
        response.errorMessage === 'Insufficient balance in your wallet.'
      ) {
        this.showModalSubject.next(true);
      }
      this.showAlert('warning', response.errorMessage);
      return;
    }

    if (response.responseCode === 500) {
      this.showAlert('error', response.errorMessage);
      return;
    }

    // default for other response codes (401, 404, etc.)
    this.showAlert('warning', response.errorMessage);
  }

  handleHttpError(error: HttpErrorResponse): void {
    if (error.status === 401) {
      this.spinner.hide();
      this.refreshtoken();
      return;
    }
    this.spinner.hide();
    this.toastr.warning(
      'Please refresh the page. If the issue persists, try logging in again.'
    );
  }

  refreshtoken() {
    const id = localStorage.getItem('userId');
    this.apicalling
      .GetCallWithoutToken('User/RefreshToken?UserId=' + id)
      .subscribe(
        (response: any) => {
          if (response.responseCode === 200) {
            localStorage.setItem('token', response.data.token);
            if (isPlatformBrowser(this.platformId)) {
              location.reload();
            }
          } else {
          }
        },
        (error) => {}
      );
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}
